import { useState } from "react";
import SidebarIcon from "../Assets/Icons/linear/menu-1.svg";
import Sidebar from "./Components/Sidebar";

function Layout({ icon, title, children }) {
  const [openSideBar, setOpenSideBar] = useState(false);

  return (
    <div className="md:my-1 md:ms-10">
      <button
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
        onClick={() => setOpenSideBar(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <img src={SidebarIcon} alt=""></img>
      </button>

      <Sidebar openSideBar={openSideBar} />

      {openSideBar ? (
        <div
          className="fixed inset-0 z-10 bg-gray-900/50"
          id="sidebarBackdrop"
          onClick={() => setOpenSideBar(false)}
        ></div>
      ) : (
        <div className="p-4 sm:ml-20">
          <div className="p-4 rounded-lg">
            {title && (
              <div className="flex items-center mb-5">
                <img src={icon} className="w-[40px] h-[40px] me-5" alt="" />
                <div className="text-[28px] font-semibold capitalize pt-1">
                  {title}
                </div>
              </div>
            )}
            {children}
          </div>
        </div>
      )}
    </div>
  );
}

export default Layout;
